<button mat-fab [matMenuTriggerFor]="menu" (menuOpened)="onMenuOpened()" class="mat-elevation-z0" [ngClass]="'avatar'">
  {{this.initials}}
</button>
<mat-menu #menu="matMenu">
  <mat-card appearance="outlined" class="example-card mat-elevation-z0">
    <button mat-fab color="red" class="mat-elevation-z0">
      {{this.initials}}
    </button>
    <h2>{{name}}</h2>
    <mat-chip-listbox class="chip-list">
      @if (this.info.studentInfo != null) {
        <!-- <mat-chip-option class="chip-font">{{this.info.studentInfo.mainGroup.name}}
        </mat-chip-option> -->
      }
    </mat-chip-listbox>

    @if (isTeamMember && hasMultipleOrganizations) {
      <mat-divider class="org-divider"></mat-divider>
      <div class="org-section" (click)="$event.stopPropagation()">
        <span class="org-label">Organization</span>
        @if (orgsLoading) {
          <mat-progress-spinner mode="indeterminate" diameter="24"></mat-progress-spinner>
        } @else {
          @for (org of (organizations$ | async); track org.id) {
            <button mat-stroked-button class="org-button"
                    [class.org-selected]="org.id === currentOrganizationId"
                    (click)="selectOrganization(org)"
                    (mouseenter)="onOrgButtonHover($event)"
                    (mouseleave)="onOrgButtonLeave($event)">
              <span class="org-button-viewport">
                <span class="org-button-track">
                  <span class="org-button-text">{{ org.name }}</span>
                </span>
              </span>
            </button>
          }
        }
      </div>
    }

    <mat-card-actions class="card-actions">
      <button (click)="navigateToChangePassword()" mat-stroked-button color="black" class="action-button">
        <mat-icon>lock</mat-icon>
        Change Password
      </button>
      <button (click)="this.logout()" mat-stroked-button color="black" class="action-button logout-button">
        <mat-icon>logout</mat-icon>
        Logout
      </button>
    </mat-card-actions>
  </mat-card>
</mat-menu>
